import api from 'services/api/microfwk';
import _ from 'lodash';

export const fetchDevices = (params = {}) =>
  api
    .get('/services/device/list', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
